import { Component } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { AuthService } from '@shared/services/auth.service'
import { ToastService } from '../../services/toast.service'
import { Router } from '@angular/router'
import { environment } from '@public/app/environments/environment'

@Component({
  selector: 'app-forgotten-password',
  templateUrl: './forgotten-password.component.html',
  styleUrls: ['./forgotten-password.component.scss'],
  standalone: false,
})
export class ForgottenPasswordComponent {
  pageTitle = 'Elfelejtett jelszó'
  forgottenPasswordForm: UntypedFormGroup

  constructor(private authService: AuthService, private toastService: ToastService, private router: Router) {
    this.forgottenPasswordForm = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
    })
  }

  onSubmit(): void {
    if (this.forgottenPasswordForm.invalid) {
      return
    }

    const url = `${environment.appUrl}/reset-password`
    const email = this.forgottenPasswordForm.value.email
    this.authService
      .sendPasswordResetEmail(email, url)
      .then(() => {
        this.toastService.showSuccess('Email elküldve. Kérjük ellenőrizd a postafiókod.')
        console.log('Missing feature: handle post-send behavior (e.g. navigate to login)')
      })
      .catch(error => {
        console.error('Password reset email error:', error)
        this.toastService.showError('Hiba történt a jelszó visszaállítási email küldésekor.')
      })
  }
}
